<template>
  <b-sidebar
    id="add-new-calendar-sidebar"
    :visible="isAddNewCalendarSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-calendar-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">Add New Calendar</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
          <!-- Name -->
          <validation-provider #default="validationContext" name="Calendar Name" rules="required">
            <b-form-group label="Calendar Name" label-for="calendar-name">
              <b-form-input
                id="calendar-name"
                v-model="calendarData.name"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="2022 Open Enrollment Calendar"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Category -->
          <validation-provider #default="validationContext" name="Category" rules="required">
            <b-form-group label="Category" label-for="category" :state="getValidationState(validationContext)">
              <v-select
                v-model="calendarData.category"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="categoryOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                input-id="calendar-category"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
              Add
            </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary" @click="hide">
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ref } from '@vue/composition-api';
import { required, alphaNum, email } from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation';
import Ripple from 'vue-ripple-directive';
import vSelect from 'vue-select';
import countries from '@/@fake-db/data/other/countries';
import store from '@/store';

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewCalendarSidebarActive',
    event: 'update:is-add-new-calendar-sidebar-active',
  },
  props: {
    isAddNewCalendarSidebarActive: {
      type: Boolean,
      required: true,
    },
    categoryOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
    };
  },
  setup(props, { emit }) {
    const blankCalendarData = {
      name: '',
      category: 'standard',
      generated: true,
      status: 'created',
    };

    const calendarData = ref(JSON.parse(JSON.stringify(blankCalendarData)));
    const resetcalendarData = () => {
      calendarData.value = JSON.parse(JSON.stringify(blankCalendarData));
    };

    const onSubmit = () => {
      console.log(`creating calendar`, calendarData.value);
      store.dispatch('app-roster/addCalendar', calendarData.value).then(() => {
        emit('refetch-data');
        emit('update:is-add-new-calendar-sidebar-active', false);
      });
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetcalendarData);

    return {
      calendarData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-calendar-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
